module.exports = __webpack_public_path__ + "static/media/spinner.1d7626e6.gif";